import poliFoundationRequest from 'src/utils/poliFoundationRequest';

type OrderData = {
  title: string;
  value: number;
  status: string;
  payment_method: string;
  contact_uuid: string;
  sales_status: string;
  responsible_uuid: string;
  observations?: string;
  attachments?: string;
};

export class OrderService {
  static async createOrder(
    data: OrderData,
    userUuid: string,
    activeAccountUuid: string
  ) {
    const url = `/orders/accounts/${activeAccountUuid}/users/${userUuid}`;
    const response = await poliFoundationRequest.post(url, data);
    return response.data;
  }
}
